<p-sidebar [(visible)]="showViewProductSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="closeSidebar()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
       
    </ng-template>
    
    <ng-template pTemplate="footer">
        <p-divider></p-divider>
        <div class="flex-row">
            <div class="col-12 py-0 text-end">
                <button mat-flat-button color="primary">Edit</button>
            </div>
        </div>
    </ng-template>
</p-sidebar>